import { render, staticRenderFns } from "./sys.vue?vue&type=template&id=49fe54cc&"
import script from "./sys.vue?vue&type=script&lang=js&"
export * from "./sys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports